import React from 'react';
const testimonials = [{
  initials: 'JR',
  quote: 'I mapped out my whole season in one night. Every single practice now has a clear goal, and I walk in knowing exactly what we are doing.',
  name: 'James R.',
  role: 'Youth Coach · Sydney, Australia'
}, {
  initials: 'CM',
  quote: 'My team improved faster in two months than in the entire previous season. The progression just makes sense and the kids feel it.',
  name: 'Coach Mike',
  role: 'U15 Coach · Toronto, Canada'
}, {
  initials: 'SL',
  quote: 'I used to spend hours online searching for drills. Now I open Basketball Ready 360 and everything I need is right there.',
  name: 'Sarah L.',
  role: 'PE Teacher · Manchester, UK'
}, {
  initials: 'DT',
  quote: 'The evaluation sheets completely changed my conversations with parents. I finally talk in numbers and they trust the process.',
  name: 'David T.',
  role: 'Head Coach · Chicago, USA'
}, {
  initials: 'EW',
  quote: 'As a first-year coach I was overwhelmed. This gave me a full system from day one and my confidence on the court doubled.',
  name: 'Emma W.',
  role: 'U13 Girls Coach · Auckland, NZ'
}, {
  initials: 'RB',
  quote: 'The Pro Tactical Kit bailed me out in three close games this year. Having those plays ready in a time-out is a game changer.',
  name: 'Ryan B.',
  role: 'Senior Coach · Dublin, Ireland'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-247">
      <div className="max-w-5xl mx-auto" data-id="element-248">
        <div className="text-center mb-12" data-id="element-249">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-250">
            What <span className="text-[#FF6B00]" data-id="element-251">coaches</span> are saying
          </h2>
          <p className="text-[#5A5A66] text-base font-bold" data-id="element-252">
            ⭐⭐⭐⭐⭐ 4.9/5 · 500+ coaches worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-253">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-254">
              <div className="flex items-center gap-3 mb-4" data-id="element-255">
                <div className="w-10 h-10 rounded-full bg-[#FF6B00] flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-256">
                  {t.initials}
                </div>
                <div className="text-[#FFD700] text-sm" data-id="element-257">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[#0A0A0A] text-sm font-medium italic leading-relaxed mb-6 flex-1" data-id="element-258">
                "{t.quote}"
              </p>
              <div data-id="element-259">
                <p className="text-[#0A0A0A] font-black text-sm" data-id="element-260">{t.name}</p>
                <p className="text-[#5A5A66] text-xs font-semibold mt-0.5" data-id="element-261">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}